<template>
  <div class="content">
    <div class="category-list-shell">
      <div class="row">
        <div class="col-sm-12" v-for="item in categories" :key="item.id">
          <card class="category-card" @click.native="goCategoryDetail(item)">
            <div class="category-card-body">
              <div class="category-order">{{ item.displayOrder }}</div>
              <div class="category-info">
                <h4 class="category-name">{{ item.name }}</h4>
                <span class="i18n-chip" v-if="i18nName(item, 'en')"> <span class="i18n-chip-locale">EN</span>{{ i18nName(item, "en") }} </span>
                <span class="i18n-chip" v-if="i18nName(item, 'ja')"> <span class="i18n-chip-locale">JA</span>{{ i18nName(item, "ja") }} </span>
              </div>
              <div class="category-badges">
                <badge v-if="isEditable(item)" type="info">수정 가능</badge>
                <badge v-if="!item.isVisible" type="default">숨김</badge>
                <badge v-else type="success">노출</badge>
                <span class="count-chip">아티스트 {{ item.unitCount || 0 }}명</span>
              </div>
              <i class="tim-icons icon-minimal-right category-arrow" />
            </div>
          </card>
        </div>
        <div class="col-sm-12" v-if="loading">
          <card>
            <div class="empty-state">
              <i class="tim-icons icon-refresh-01 empty-state-icon empty-state-icon-spin" />
              <p class="empty-state-title">카테고리 목록을 불러오는 중입니다</p>
            </div>
          </card>
        </div>
        <div class="col-sm-12" v-else-if="!categories.length">
          <card>
            <div class="empty-state">
              <i class="tim-icons icon-badge empty-state-icon" />
              <p class="empty-state-title">등록된 카테고리가 없습니다</p>
              <p class="empty-state-desc">카테고리는 백엔드에서 관리되며, 등록되면 이 목록에 표시됩니다.</p>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, Badge } from "@/components/index";
import { Toast } from "@/util/Toast";

export default {
  components: {
    Card,
    Badge,
  },
  async created() {
    await this.getCategories();
  },
  data() {
    return {
      categories: [],
      loading: true,
    };
  },
  methods: {
    async getCategories() {
      this.loading = true;
      return this.$axios
        .get("/webArtistCategories")
        .then((res) => {
          this.categories = res.data.data;
        })
        .catch(() => {
          Toast.error("카테고리 목록을 불러오는 중 에러가 발생하였습니다");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    i18nName(item, locale) {
      const i18n = item.nameI18N || item.nameI18n;
      return i18n ? i18n[locale] : null;
    },
    isEditable(item) {
      // 현재는 categoryKey가 "popular"인 카테고리만 아티스트 추가/정렬/제거가 가능하다.
      // 다음 스콥부터 다른 카테고리도 순차적으로 지원할 예정.
      return item.categoryKey === "popular";
    },
    goCategoryDetail(item) {
      this.$router.push(`/blipArtist/blipArtistCategoryDetail?categoryId=${item.id}&categoryKey=${item.categoryKey}`);
    },
  },
};
</script>
<style scoped>
.category-list-shell {
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
}
.category-card {
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.category-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
}
.category-card-body {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
}
.category-order {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  font-size: 13px;
  font-weight: 600;
  color: #9a9a9a;
}
.category-info {
  flex: 1;
  text-align: left;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  row-gap: 6px;
}
.category-name {
  margin: 0 8px 0 0;
  font-size: 16px;
  font-weight: 600;
}
.i18n-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px 2px 2px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  font-size: 12px;
  color: #cbcbcb;
}
.i18n-chip-locale {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 8px;
  border-radius: 10px;
  background: rgba(29, 140, 248, 0.2);
  color: #1d8cf8;
  font-size: 10px;
  font-weight: 700;
}
.category-badges {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.count-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  color: #cbcbcb;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.category-arrow {
  font-size: 14px;
  opacity: 0.5;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 20px;
  text-align: center;
}
.empty-state-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 16px;
  border-radius: 50%;
  background: rgba(29, 140, 248, 0.12);
  color: #1d8cf8;
  font-size: 24px;
}
.empty-state-icon-spin {
  animation: empty-state-spin 1s linear infinite;
}
@keyframes empty-state-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.empty-state-title {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 700;
}
.empty-state-desc {
  margin: 0;
  font-size: 13px;
  color: #9a9a9a;
}
</style>
